<section class="tera-global-search pointer-events-auto">
  <div class="tera-search-top">
    <label
      class="tera-search-input-wrap"
      [class.tera-search-input-focused]="isSearchFocused"
      for="global-search-input"
      #searchInputWrap
      matAutocompleteOrigin
      #searchOrigin="matAutocompleteOrigin"
    >
      <mat-icon
        class="tera-search-leading-icon"
        [svgIcon]="'heroicons_outline:action_key'"
      ></mat-icon>
      <input
        #globalSearchInput
        id="global-search-input"
        class="tera-search-input dark:placeholder:text-slate-300"
        type="text"
        [value]="searchQuery"
        [matAutocomplete]="globalSearchAuto"
        [matAutocompleteConnectedTo]="searchOrigin"
        placeholder="Rechercher des acteurs, projets, dossiers, lots CSS…"
        (input)="onSearch($any($event.target).value)"
        (focus)="onSearchFocus()"
        (blur)="onSearchBlur()"
      />
    </label>

    <button
      class="tera-search-fullscreen-btn rounded-lg p-2"
      [matTooltip]="tooltip || 'Passer en plein écran'"
      (click)="toggleFullscreen()"
    >
      <div class="flex items-center">
        <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
      </div>
    </button>
  </div>
</section>

<mat-autocomplete
  #globalSearchAuto="matAutocomplete"
  [displayWith]="displaySearchResult"
  [panelWidth]="searchPanelWidth"
  [class]="'tera-global-search-panel'"
>
  <ng-container *ngIf="hasGroupedResults; else noResultsTpl" class="p-4">
    <div class="tera-preview-header p-4">
      <h3>Résultats de recherche</h3>
      <p>Affichage des correspondances pour votre requête <b>{{ searchQuery }}</b></p>
    </div>

    <section class="tera-preview-sections p-4">
      <div
        class="tera-preview-section"
        *ngFor="let group of groupedResults; trackBy: trackByGroupId"
        [attr.data-group]="group.id"
      >
        <div class="tera-preview-section-head">
          <div class="tera-preview-section-title flex items-center gap-2">
            <mat-icon class="flex" [svgIcon]="getTypeIcon(group.id)"></mat-icon>
            <span class="flex">{{ getTypeLabel(group.id) | uppercase }}</span>
          </div>
          <span class="tera-preview-section-count">{{ group.results.length }} résultats</span>
        </div>

          <div class="tera-preview-chip-list">
          <mat-option
            class="tera-preview-chip-option"
            *ngFor="let result of group.results | slice:0:(displayedCounts[group.id] || searchResultsPerCategoryLimit); trackBy: trackByResultId"
            [value]="result.title"
            [matTooltip]="getResultTooltip(result)"
            matTooltipPosition="right"
            (click)="openResult(result, $event)"
          >
            <div class="tera-preview-chip">
              <!-- <mat-icon [svgIcon]="getTypeIcon(group.id)"></mat-icon> -->
              <span>{{ result.title }}</span>
            </div>
          </mat-option>
        </div>
        <div class="mt-2">
          <button
            mat-button
            color="primary text-xs"
            matTooltip="Afficher les 6 éléments suivants"
            *ngIf="group.results.length > (displayedCounts[group.id] || searchResultsPerCategoryLimit)"
            (click)="showMore(group.id)"
          >
            Voir plus
          </button>
        </div>
      </div>
    </section>
  </ng-container>
</mat-autocomplete>

<ng-template #noResultsTpl>
  <mat-option disabled>
    {{
      isSearchDataLoading
        ? 'Chargement des données de recherche...'
        : 'Aucune donnée correspondante dans les acteurs, projets, dossiers ou lots CSS.'
    }}
  </mat-option>
</ng-template>

<ng-template #defaultIconTpl>
  <mat-icon [svgIcon]="'heroicons_outline:arrows-expand'"></mat-icon>
</ng-template>